import { render, staticRenderFns } from "./TabelaSecretaria.vue?vue&type=template&id=70307e0f"
import script from "./TabelaSecretaria.vue?vue&type=script&lang=js"
export * from "./TabelaSecretaria.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports